import { useLocation, useNavigate } from 'react-router';
import { useCallback } from 'react';

export const useRemoveSearchParam = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return useCallback(
    (paramToRemove: string) => {
      const searchParams = new URLSearchParams(location.search);
      searchParams.delete(paramToRemove);
      const newSearch = searchParams.toString();

      navigate(
        {
          pathname: location.pathname,
          search: newSearch ? `?${newSearch}` : '',
        },
        { replace: true }
      );
    },
    [location, navigate]
  );
};
